'use strict';

angular.module('ClinicApp').controller('ModalConfirmMessage', function($scope, $modalInstance, $sce, confirmText) {
  $scope.confirmText = $sce.trustAsHtml(confirmText);

  $scope.confirm = function() {
    $modalInstance.close();
  };

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };
});
